// Redirection for product to supported Bundle
export const handleSignupRouteRedirects = ({
    product,
    bundle
}: {
    product: string;
    bundle: string;
}): boolean => {
    const townsquareRedirectionURL =
        "https://community.atlassian.com/t5/Atlas-Group-articles/Atlas-is-evolving/ba-p/2686154";
    const productParamRedirect = (): boolean => {
        const productBundleMap: { [key: string]: string } = {
            "loom": "loom",
            "com.atlassian.bitbucket": "bitbucket",
            "opsgenie": "opsgenie",
            "compass": "compass",
            "statuspage": "statuspage"
        };
        const bundleKey = productBundleMap[product];
        if (bundleKey && bundle !== bundleKey) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("bundle", bundleKey);
            currentUrl.searchParams.delete("product");
            window.location.assign(currentUrl.toString());
            return true;
        }
        if (product === "atlassian-whiteboard") {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("product", "confluence.ondemand");
            window.location.assign(currentUrl.toString());
            return true;
        }
        if (product === "townsquare") {
            window.location.assign(townsquareRedirectionURL);
            return true;
        }
        return false;
    };
    if (product && productParamRedirect()) {
        return true;
    }
    const bundleParamRedirect = (): boolean => {
        const isJswRedirectBundle =
            bundle === "avocado" ||
            bundle === "jira-ops" ||
            bundle === "devops";
        const isBitbucketRedirectBundle =
            bundle === "jira-software-bitbucket" ||
            bundle === "bitbucket-jira-software";
        if (isJswRedirectBundle || isBitbucketRedirectBundle) {
            const redirectBundle = isJswRedirectBundle
                ? "jira-software"
                : "bitbucket";
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("bundle", redirectBundle);
            window.location.assign(currentUrl.toString());
            return true;
        }
        const isTeamCentralBundle =
            bundle === "team-central" || bundle === "atlas";
        if (isTeamCentralBundle) {
            window.location.assign(townsquareRedirectionURL);
            return true;
        }
        return false;
    };
    if (bundle && bundleParamRedirect()) {
        return true;
    }
    return false;
};
